import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { VoiceBroadcastSchema } from "../../Schemas/Broadcast";

interface Filter extends IFilterSchema {
  column: BroadcastingListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: BroadcastingListColumnSortable;
}

export enum BroadcastingListColumnFilterable {
  ID = "id",
  WORKSPACE_ID = "workspace_id",
  USER_ID = "user_id",
  RETRY_COUNT = "retry_count",
  RETRY_INTERVAL = "retry_interval",
  FILE_DURATION = "file_duration",
  TOTAL_NUMBERS = "total_numbers",
  COST_INTERVAL_AMOUNT = "cost_interval_amount",
  COST_INTERVAL_VALUE = "cost_interval_value",
  ESTIMATED_DURATION = "estimated_duration",
  ESTIMATED_COST = "estimated_cost",
  ACTUAL_DURATION = "actual_duration",
  ACTUAL_COST = "actual_cost",
  UPDATED_AT = "updated_at",
  CREATED_AT = "created_at",
  STATUS = "status",
}
export enum BroadcastingListColumnSortable {
  ID = "id",
  RETRY_COUNT = "retry_count",
  RETRY_INTERVAL = "retry_interval",
  FILE_DURATION = "file_duration",
  TOTAL_NUMBERS = "total_numbers",
  COST_INTERVAL_AMOUNT = "cost_interval_amount",
  COST_INTERVAL_VALUE = "cost_interval_value",
  ESTIMATED_DURATION = "estimated_duration",
  ESTIMATED_COST = "estimated_cost",
  ACTUAL_DURATION = "actual_duration",
  ACTUAL_COST = "actual_cost",
  UPDATED_AT = "updated_at",
  CREATED_AT = "created_at",
}

interface BroadcastingListUrlParams {
  workspaceId: number;
}

interface BroadcastingListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

interface BroadcastingListResponseBody extends IResponseBody {
  data: {
    voice_broadcasts: VoiceBroadcastSchema[];
    total: number;
  };
}

export class BroadcastingListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/voice-broadcasts`;
  }

  async send(
    queryStrings?: BroadcastingListQueryString
  ): Promise<BroadcastingListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
